import React from 'react'
import styled from 'styled-components'
import { Modal } from 'antd'
import doctorImageSrc from 'src/assets/images/common/doctor-image.png'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PATH as AUTOMATIC_PLAN_PATH } from 'src/pages/automaticPlan'
import LocalStorage from 'src/utils/LocalStorage'
import useCreateTreatment from 'src/hook/useCreateTreatment'

interface PrecautionModalProps {
  isOpen: boolean
  onClose?: () => void
}

const PrecautionModalPlan: React.FC<PrecautionModalProps> = ({ isOpen }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menuId')
  const planId = searchParams.get('planId')
  const accessToken = LocalStorage.accessToken
  const { createTreatment } = useCreateTreatment()

  const handleOkClick = async () => {
    if (accessToken && menuId) {
      const newUserTreatment = await createTreatment(Number(menuId), planId, {})
      if (newUserTreatment) {
        LocalStorage.setUserTreatmentId(newUserTreatment.id)
      }
    }

    LocalStorage.setTelemedicine('false')
    navigate(
      `${AUTOMATIC_PLAN_PATH.QUESTIONS.replace(
        ':id',
        menuId || '',
      )}?${searchParams.toString()}`,
    )
  }

  return (
    <Modal
      open={isOpen}
      centered
      closable={false}
      footer={null}
      className="precaution-modal"
    >
      <Container>
        <DoctorImage src={doctorImageSrc} alt="doctor" />
        <Title>
          ご希望のプランの処方が可能か確認するため
          <br />
          問診にご回答ください。
        </Title>
        <Description>
          ※診察方法は、医師の判断により、必要に応じてビデオ通話、
          チャット、録画映像の送付、または電話等の多様な情報収集手段を
          用いる場合があります。
        </Description>
        <OkButton onClick={handleOkClick}>OK</OkButton>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  text-align: center;
  padding: 16px;
`

const DoctorImage = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 16px;
`

const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`

const Description = styled.p`
  font-size: 12px;
  color: #333;
  text-align: justify;
  margin-bottom: 20px;
  line-height: 1.5;
  text-align: center;
`

const OkButton = styled.button`
  background-color: #00c853;
  border: none;
  padding: 3px 30px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;
`

export default PrecautionModalPlan
